angular
	.module 'App.Directive'
	.directive 'galleryImageUrl', ($parse, ImageService) ->
		restrict: 'A'
		link: (scope, element, attributes) ->
			getImage = =>
				return $parse(attributes.galleryImageUrl)(scope)

			setElementImageUrl = (url = null) =>
				if _.isEmpty(url)
					element
						.closest '.gallery-image-block'
						.addClass 'image-error'

					if element[0].tagName == 'IMG'
						element.removeAttr 'src'
					else
						element.css {backgroundImage: ''}

					return

				url = ImageService.resize(url)

				if element[0].tagName == 'IMG'
					element.attr 'src', url
				else
					element
						.css {backgroundImage: "url('#{url}')"}
						.closest '.gallery-image-block'
						.removeClass 'image-error'

					img = new Image()
					img.src = url
					img.onerror = =>
						element
							.closest '.gallery-image-block'
							.addClass 'image-error'

			setElementImage = (image) =>
				if !(image instanceof File)
					setElementImageUrl image

					return

				reader = new FileReader()
				reader.onload = =>
					setElementImageUrl(reader.result)
				reader.readAsDataURL image

			setElementImage(getImage())

			scope.$watch attributes.galleryImageUrl, => setElementImage(getImage())
